import { defineMessages, useIntl } from 'react-intl'

import { type OrderStatusConfigLabels } from './AccountOverviewLastOrderShippingStatusTypes'

const userSubOrderShippingStatusMessages = defineMessages({
  canceled: {
    id: 'account.orders.status.canceled',
  },
  cancelRequested: {
    id: 'account.orders.cancel.status.requested',
  },
  closed: {
    id: 'account.orders.status.closed',
  },
  completed: {
    id: 'account.orders.status.completed',
  },
  delivered: {
    id: 'account.orders.delivered',
  },
  dispatched: {
    id: 'account.orders.status.dispatched',
  },
  new: {
    id: 'account.orders.status.new',
  },
  processing: {
    id: 'account.orders.status.processing',
  },
  readyForPickup: {
    id: 'account.orders.status.readyForPickup',
  },
  shipped: {
    id: 'account.lastOrder.estimatedDelivery.label',
  },
  waitingForPrepayment: {
    id: 'account.orders.status.waitingForPrepayment',
  },
})

export const useUserSubOrderShippingStatusLabels = (): Record<
  OrderStatusConfigLabels,
  string
> => {
  const intl = useIntl()

  return {
    canceled: intl.formatMessage(userSubOrderShippingStatusMessages.canceled),
    cancelRequested: intl.formatMessage(
      userSubOrderShippingStatusMessages.cancelRequested,
    ),
    closed: intl.formatMessage(userSubOrderShippingStatusMessages.closed),
    completed: intl.formatMessage(userSubOrderShippingStatusMessages.completed),
    delivered: intl.formatMessage(userSubOrderShippingStatusMessages.delivered),
    dispatched: intl.formatMessage(
      userSubOrderShippingStatusMessages.dispatched,
    ),
    new: intl.formatMessage(userSubOrderShippingStatusMessages.new),
    processing: intl.formatMessage(
      userSubOrderShippingStatusMessages.processing,
    ),
    readyForPickup: intl.formatMessage(
      userSubOrderShippingStatusMessages.readyForPickup,
    ),
    shipped: intl.formatMessage(userSubOrderShippingStatusMessages.shipped),
    waitingForPrepayment: intl.formatMessage(
      userSubOrderShippingStatusMessages.waitingForPrepayment,
    ),
  }
}
